import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const addEmployerRefereeMutation = gql`
  mutation addEmployerReferee(
    $customerId: String!
    $subjectId: String!
    $userId: String!
    $email: String!
    $name: String!
    $phone: String!
    $incomeId: String
  ) {
    addEmployerReferee(
      customerId: $customerId
      subjectId: $subjectId
      userId: $userId
      email: $email
      name: $name
      phone: $phone
      incomeId: $incomeId
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  email: string
  name: string
  phone: string
  incomeId: string
}

export type AddEmployerRefereeData = {
  addEmployerReferee: string | unknown
}

export const useAddEmployerRefereeMutation: WrappedMutation<
  AddEmployerRefereeData,
  MutationVars
> = () =>
  useMutation<AddEmployerRefereeData, MutationVars>(addEmployerRefereeMutation, {
    client: agentClient,
  })
